import { GraphQLID, GraphQLNonNull, GraphQLEnumType } from 'graphql'
import {
  Substatus,
  SubstatusName
} from '../../../components/vulnerability-status/status'

export const substatusType = new GraphQLEnumType({
  name: 'SubstatusArgs',
  description: 'Vulnerability Substatus Name',
  values: {
    URL: {
      value: Substatus.TRUSTED.name
    },
    FP: {
      value: Substatus.FALSE_POSITIVE.name
    },
    SC: {
      value: Substatus.INTERNAL_SECURITY_CONTROL.name
    },
    EC: {
      value: Substatus.EXTERNAL_SECURITY_CONTROL.name
    },
    OT: {
      value: Substatus.OTHER.name
    }
  }
})

export interface VulnerabilitySubstatusAliasArgs {
  readonly organizationUuid: string
  readonly substatus: SubstatusName
}

export const vulnerabilitySubstatusAliasArgs = {
  organizationUuid: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  substatus: {
    description:
      'The vulnerability substatus name of the alias being requested',
    type: new GraphQLNonNull(substatusType)
  }
}
